var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-card-item"},[_c('b-card-text',{staticClass:"title-card-item"},[_vm._v(_vm._s(_vm.title))]),_c('b-card-text',{staticClass:"text-card-item"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }